import { render, staticRenderFns } from "./REAIPrompt.vue?vue&type=template&id=8855cabc&scoped=true"
import script from "./REAIPrompt.vue?vue&type=script&lang=js"
export * from "./REAIPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8855cabc",
  null
  
)

export default component.exports